import getRandomPlaceholder from "@/assets/placeholder";
import { getFileURL, getFileURLWithCache } from "@/hooks/useUploadFileAvatar";
import { StaticImageData } from "next/image";
import { useEffect, useMemo, useState } from "react";

const useGetAvatarImg = (
  src: string | StaticImageData,
  id: string,
  imageCache: Map<string, boolean>
) => {
  const [imgUrl, setImgUrl] = useState<string | StaticImageData>();
  const [isLoadingFetch, isLoadingFetchSet] = useState(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(() =>
    typeof src === "string" ? !!imageCache.get(src) : false
  );
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (!src || isError) {
      setImgUrl(getRandomPlaceholder(id));
    }
    if (typeof src === "string" && src?.includes("https://")) {
      setImgUrl(src);
    }
    if (typeof src === "object") {
      setImgUrl(src);
    }
    if (typeof src === "string" && !src?.includes("https://") && !isError) {
      (async () => {
        isLoadingFetchSet(true);
        const fetchedImageUrl = await getFileURL(src as string);
        setImgUrl(fetchedImageUrl as string);
        isLoadingFetchSet(false);
      })();
    }
  }, [src, isError]);

  // If browser cache already has the image, mark loaded (avoid flicker)
  useEffect(() => {
    const tmp = new window.Image();
    if (typeof imgUrl === "string" && imgUrl !== "GET") {
      tmp.src = imgUrl;
      if (tmp.complete) {
        imageCache.set(imgUrl, true);
        setIsLoaded(true);
        // No need to call onMeasured when already cached (no size change)
      }
    }
  }, [imgUrl]);

  return {
    isLoaded,
    setIsError,
    imgUrl,
    setIsLoaded,
    isLoadingFetch
  };
};

export default useGetAvatarImg;
